import { FormFieldsConfig } from '../../types';

export const defaultFieldsConfig: FormFieldsConfig = {
  type: {
    label: 'Tipologia immobile',
    ariaLabel: 'Campo per selezionare la tipologia dell\'immobile',
  },
  address: {
    label: 'Dove si trova il tuo immobile?',
    ariaLabel: 'Campo per inserire l\'indirizzo del tuo immobile',
    placeholder: 'Es: Via Nino Bixio, 7, Milano',
  },
  floor: {
    label: 'A che piano si trova il tuo immobile?',
    ariaLabel: 'Campo per inserire il piano del tuo immobile',
  },
  size: {
    label: 'Di quanti metri quadrati è l\'immobile?',
    ariaLabel: 'Campo per inserire i mq del tuo immobile',
    placeholder: 'Es: 60',
  },
  status: {
    label: 'Come definiresti il tuo immobile?',
    ariaLabel: 'Campo per inserire lo stato del tuo immobile',
  },
  features: {
    label: 'L\'immobile dispone di:',
  },
  button: {
    label: 'Prosegui',
    ariaLabel: 'Prosegui',
  },
};
